import PrograseReportInwordList from "./PrograseReportInwordList"
import PrograseReportOutwordList from "./PrograseReportOutwordList"


export {PrograseReportInwordList,PrograseReportOutwordList}